import { startTransition } from 'react'

import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-fetch-backend'
import { version } from 'package.json'
import { hydrateRoot } from 'react-dom/client'
import { I18nextProvider, initReactI18next } from 'react-i18next'
import { HydratedRouter } from 'react-router/dom'
import { v4 as uuidv4 } from 'uuid'

import { i18nconfig } from '~/portal/i18n.ts'
import { enabledBreadcrumbTypes, shouldDropBugsnagEvent } from '~/portal/utils/bugsnag'
import { registerPreloadErrorReload } from '~/portal/utils/preloadErrorReload'
import { Environment } from '~/shared/types/environment'

registerPreloadErrorReload()

if (globalThis.window['ENV']?.bugsnagApiKey && globalThis.window['ENV']?.env !== Environment.LOCAL) {
  Bugsnag.start({
    apiKey: globalThis.window['ENV']?.bugsnagApiKey,
    plugins: [new BugsnagPluginReact()],
    appVersion: version,
    appType: 'spa',
    releaseStage: globalThis.window['ENV']?.env,
    enabledBreadcrumbTypes,
    onError: (event) => {
      if (shouldDropBugsnagEvent(event)) {
        return false
      }

      const errorId = uuidv4().split('-')[0]
    
      event.addMetadata('error', {
        id: errorId,
      })
    
      event.groupingHash = event.errors[0].errorMessage
    }
  })
}

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(Backend)
  .init({
    ...i18nconfig(),
    ns: ['common'],
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['htmlTag'],
      caches: [],
    },
    react: {
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'em', 'p', 'ol', 'ul', 'li', 'a'],
    }
  })
  .then(() => startTransition(() => {
    hydrateRoot(document,
      <I18nextProvider i18n={i18next}>
        <HydratedRouter />
      </I18nextProvider>
    )
  })
  )